import React, { useEffect, useMemo, useRef } from 'react';
import './HighlightTopPage.scss';
import { Wrapper } from '../../utils/components';
import Icon from '../../atoms/icon';
import { ButtonWithLink as Button } from '../button/Button';
import { getCommonOrganismData } from '../../utils/functions';
import classNames from 'classnames';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import withPreview from '../../utils/with-preview';
import FeatherX from '../../atoms/static-icons/feather-x';
import useCloseBanner from '../../utils/hooks/useCloseBanner';

const HighlightTopPage = ({ data }) => {
  const storageKey = data.liferayFields.articleId;
  const storageKeys = useMemo(() => [storageKey], [storageKey]);
  const [hiddenItems, removeBanner] = useCloseBanner(storageKeys);
  const hide = hiddenItems ? hiddenItems[storageKey] : true;

  useEffect(() => {
    if (hide) {
      const event = new CustomEvent('banner-top-closed', {
        detail: {
          hide,
        },
      });
      document.dispatchEvent(event);
    }
  }, [hide]);

  const internalRef = useRef();
  useEffect(() => {
    const refEl = internalRef.current;
    if (!hide && refEl) {
      const resizeListener = () => {
        const { height } = refEl.getBoundingClientRect();
        const event = new CustomEvent('banner-top-resize', {
          detail: {
            height,
          },
        });
        document.dispatchEvent(event);
      };
      resizeListener();
      window.addEventListener('resize', resizeListener);
      return () => window.removeEventListener('resize', resizeListener);
    }
  }, [hide]);

  const { htmlTagWrapper } = getCommonOrganismData(data);
  const bannerTop = data?.bannerTop;
  const type = data?.type?.value[0];

  return hide ? null : (
    <Wrapper
      data-module-code='C-44'
      data-module-name='highlight-top-page'
      tag={htmlTagWrapper}
      className={classNames(`highlight-top-page`, {
        'fascia-informativa-cta--colored-background':
          bannerTop?.content?.colorBannerTop?.value !== 'transparent',
      })}
      style={{
        '--bg-cta': `var(--${bannerTop?.content?.colorBannerTop?.value})`,
      }}
    >
      <div
        ref={internalRef}
        className='highlight-top-page__wrapper wrapper'
        data-type={type}
      >
        <section className='highlight-top-page__band' data-type={type}>
          <div className='highlight-top-page__band-wrapper'>
            {(bannerTop?.content?.bannerTopImage ||
              bannerTop?.content?.iconSvgIdBannerTop?.value) && (
              <div className='highlight-top-page__band-img-wrapper'>
                {bannerTop?.content?.bannerTopImage && (
                  <GatsbyImage
                    className='highlight-top-page__band-img'
                    image={getImage(
                      bannerTop?.content?.bannerTopImage.node.gatsbyImageData
                    )}
                    alt='Image'
                  />
                )}
                {!bannerTop?.content?.bannerTopImage &&
                  bannerTop?.content?.iconSvgIdBannerTop?.value && (
                    <Icon
                      icon={bannerTop?.content?.iconSvgIdBannerTop?.value}
                      thickness={
                        bannerTop?.content?.iconSvgIdBannerTop?.content
                          ?.iconThicknessBannerTop?.value?.[0]
                      }
                      className='highlight-top-page__band-icon'
                    />
                  )}
              </div>
            )}
            <div className='highlight-top-page__band-text-wrapper'>
              <Wrapper
                tag={
                  bannerTop?.content?.tagTitleBannerTop
                    ? bannerTop?.content?.tagTitleBannerTop?.value[0]
                    : 'p'
                }
                className='highlight-top-page__band-text-title'
              >
                {bannerTop?.content?.titleBannerTop?.value}
              </Wrapper>
              {bannerTop?.content?.textBannerTop?.value && (
                <p
                  className='highlight-top-page__band-text-description'
                  dangerouslySetInnerHTML={{
                    __html: bannerTop?.content?.textBannerTop?.value,
                  }}
                ></p>
              )}
            </div>
          </div>
          <div className='highlight-top-page__band-btn-wrapper'>
            <Button
              type={
                bannerTop?.content?.ctaLabelBannerTop?.content?.ctaTypeBannerTop
                  ?.value[0]
              }
              backgroundColor={
                bannerTop?.content?.ctaLabelBannerTop?.content
                  ?.ctaColorBannerTop?.value[0]
              }
              icon={
                bannerTop?.content?.ctaLabelBannerTop?.content
                  ?.iconSvgIdCtaBannerTop?.value
              }
              iconThickness={
                bannerTop?.content?.iconSvgIdCtaBannerTop?.content
                  ?.iconThicknessCtaBannerTop?.value?.[0]
              }
              href={
                bannerTop?.content?.ctaLabelBannerTop?.content?.ctaLinkBannerTop
                  ?.value
              }
              title={bannerTop?.content?.ctaLabelBannerTop?.value}
              text={bannerTop?.content?.ctaLabelBannerTop?.value}
            ></Button>
          </div>
        </section>
        <button
          name={storageKey}
          className='modal__button-close highlight-top-page__close-button'
          onClick={removeBanner}
        >
          <FeatherX className='highlight-top-page__close-icon' />
        </button>
      </div>
    </Wrapper>
  );
};

export default withPreview(HighlightTopPage);
